import { GetStaticProps } from 'next';
import { initializeApollo } from '../../utils/apollo';
import { Testimony } from '../../types/schema';
import { TESTIMONIALS_PAGE } from '../../queries/testimonials';
import PageLayout, { MenuProps } from '../../layouts/Page';
import TestimonialsPage from '../../components/elements/TestimonialsPage';
import { flatten } from '../../utils/object';
import { Error, sendError } from '../../utils/error';

type TestimonialsProps = {
  testimonies: Testimony[];
  menus: MenuProps;
};

const Testimonials: React.FC<TestimonialsProps> = ({ testimonies, menus }) => {
  return (
    <PageLayout menus={menus} locale="pt" isHeaderTransparent>
      <TestimonialsPage testimonies={testimonies} language="pt" />
    </PageLayout>
  );
};

/**
 * getStaticProps
 */
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  if (locale === 'en') {
    return {
      notFound: true,
    };
  }

  try {
    const apolloClient = initializeApollo();
    const { data } = await apolloClient.query({
      query: TESTIMONIALS_PAGE,
      variables: {
        locale,
      },
    });

    const newData = flatten(data);

    return {
      props: {
        testimonies: newData.testimonies,
        locale,
        menus: {
          header: newData.header,
          technologies: newData.technologies,
          services: newData.services,
          footerPt: newData.footerPt,
          footerEn: newData.footerEn,
        },
      },
    };
  } catch (error) {
    sendError({ error: error as Error, message: 'Error on depoimentos page' });
    return {
      notFound: true,
    };
  }
};

export default Testimonials;
